module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MS-d6b5eb017f5accf9d6e1d0b5e6861601.png";